import {
  EventNoteIcon_default
} from "./chunk-GHBML7DW.mjs";
export {
  EventNoteIcon_default as default
};
